module.exports = __webpack_public_path__ + "static/img/43-1.0fc19c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/43-1.jpg
// module id = i88n
// module chunks = 0